import React, { useState, useEffect } from 'react';
import '../CreateHira/createhira.scss';
import { Button, CircularProgress, TextField } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as hiraService from "../../../services/HiraService";
import {baseUrl} from "../../../config/config"
import BackButton from '../../../components/BackButton/BackButton';
import Swal from 'sweetalert2';

const EditHira = () => {
  const [lohateny, setLohateny] = useState("");
  const [tonony, setTonony] = useState("");
  const [audio, setAudio] = useState(null); 
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams(); 

  useEffect(() => {
    hiraService.getHiraById(id)
      .then((hira) => {
        console.log(hira.audio);
        setLohateny(hira.lohateny);
        setTonony(hira.tonony);
        const file = new File([hira.audio], `${hira.audio.split('/')[1]}`, { type: "audio/mp3" });
        setAudio(hira.audio);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération du Hira:", error);
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
  
    setIsLoading(true);
  
    const formData = new FormData();
    formData.append('lohateny', lohateny);
    formData.append('tonony', tonony);
    formData.append('audio', audio);
    console.log(audio);
  
    // Envoyer la requête de mise à jour avec l'ID du TenyZaraina
    hiraService.updateHiraById(id, formData)
      .then((res) => {
        if (res.status === 200) {
          Swal.fire(
            'Hira mis à jour !',
            'Mise à jour réussie',
            'success'
          ).then(() => {
            navigate(`/hira`);
          });
        } else {
          Swal.fire(
            'Nope',
            'Une erreur s\'est produite',
            'error'
          );
        }
      })
      .catch((err) => {
        console.error("Erreur lors de la mise à jour du Hira :", err);
        Swal.fire(
          'Nope',
          'Une erreur s\'est produite',
          'error'
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };  

  return (
    <div>
      <div className="back" style={{margin:"10px 0 0 30px"}}>
        <BackButton />
      </div>

      <div className="addHira">
        <span className='titre'>Modification Hira</span>

        <div className='form-hira'>
          <form onSubmit={handleSubmit}>
            <TextField
              type="text"
              label="Lohateny"
              variant="outlined"
              margin='normal'
              multiline
              value={lohateny}
              onChange={(e) => setLohateny(e.target.value)} 
              required
            />
            <TextField
              type="text"
              label="Tonony"
              variant="outlined"
              margin='normal'
              multiline
              value={tonony}
              onChange={(e) => setTonony(e.target.value)} 
            />
            <TextField
              type="file"
              label="Ajouter une audio"
              variant="outlined"
              margin='normal'
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setAudio(e.target.files[0])} 
              accept="audio/mp3"
            />
            {audio !== null && (
              <audio className="image-preview" controls>
                  <source src={typeof audio !== 'string' ? 
                    URL.createObjectURL(audio):
                    `${baseUrl}/${audio}`} 
                    type='audio/mp3' 
                  />
              </audio>
            )}
            <Button type="submit" variant="contained" disabled={isLoading}>
              {isLoading ? <CircularProgress size={24}/> : "Valider"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditHira;
